"use client";

import { useState, PropsWithChildren, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./apiInterceptor";

export default function Providers({ children }: PropsWithChildren) {
    useEffect(() => {
        window.next_hydrated = true;

        return () => {
            window.next_hydrated = undefined;
        };
    }, []);

    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        staleTime: 1000 * 60 * 60 // 1 hour
                    }
                }
            })
    );

    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
